// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1TfjN","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2XU-o","obliqueLine":"membershipbadge_obliqueLine__38VpD"};